import type { DependencyList } from 'react'
import { useEffect } from 'react'

export const useDebugEffect = (
  effectFn: () => void | (() => void),
  deps: DependencyList,
) => {
  if (!Array.isArray(deps)) {
    throw new Error('useDebugEffect deps must be an array')
  }

  useEffect(() => {
    try {
      const cleanup = effectFn()

      return () => {
        if (typeof cleanup === 'function') {
          cleanup()
        }
      }
    } catch (error) {
      console.error('Error in useDebugEffect:', error)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps])
}

export default useDebugEffect
